module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon12.da874b9f.png";